
// import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom";
import AddMaterialFactibilidadCorporativoPage from "../../shared/add_solicitud_factibilidad_corporativo/AddMaterialFactibilidadCorporativoPage";
import { useFetchGetByIdfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { useCheckPermissions } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";

export default function ViewFactibilidadCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_view_factibilidadcoorporativa);

  const { idfactibilidadcorporativa } = useParams();

  // const { data: dataProspecto, isLoading: isLoadingProspecto } = useGetProspectoByIdProspecto(idprospecto!);

  const { data: dataFactibilidadCorporativa, isLoading: isLoadingFactibilidadCorporativa } = useFetchGetByIdfactibilidadCorporativos(idfactibilidadcorporativa!)

  if (isLoadingFactibilidadCorporativa) return <LoaderComponent />

  if (!dataFactibilidadCorporativa) return null;

  return (
    <AddMaterialFactibilidadCorporativoPage
      title="Factibilidad Corporativa Aprobada"
      // dataProspecto={dataProspecto!}
      dataFactibilidadCorporativa={dataFactibilidadCorporativa?.data}
      dataPreventa={dataFactibilidadCorporativa?.data?.preventa_corporativa_data!}
      updateFactibilidad={false}
      showSaveButton={false}
      DISABLE_FIELD={
        true
      }
    />
  );

}